import { createTheme, type MantineColorsTuple } from '@mantine/core';

// Brand colors are flat: every shade index resolves to the same value.
const flat = (color: string) => Array.from({ length: 10 }, () => color) as unknown as MantineColorsTuple;

export const theme = createTheme({
    colors: {
        'pq-red': flat('#B31E3B'),
        'pq-dark-red': flat('#910933'),
        'pq-gray': flat('#858585'),
        'pq-light-gray': flat('#E8E8E8'),
        'pq-med-gray': flat('#B3B3B3'),
        'pq-dark-gray': flat('#4D4D4D'),
    },
});
